import React, { useState } from 'react';
import {
  Create,
  DateInput,
  NumberInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from 'react-admin';
import { endOfMonth, format, startOfMonth } from 'date-fns';
import { choices, LicenseeStatus, planNameChoices } from './constants';

export const ContractCreate = (props) => {
  const [licenseeStatus, setLicenseeStatus] = useState<string>();

  const isLegal = licenseeStatus === LicenseeStatus.LEGAL;
  const isIndividualEntrepreneur =
    licenseeStatus === LicenseeStatus.INDIVIDUAL_ENTREPRENEUR;

  return (
    <Create {...props}>
      <SimpleForm redirect="list">
        <SelectInput
          source="planName"
          label="Тариф"
          choices={planNameChoices}
        />
        <DateInput
          label="Действует с"
          source="dateFrom"
          defaultValue={format(startOfMonth(new Date()), 'yyyy-MM-dd')}
        />
        <DateInput
          label="Действует по"
          source="dateTo"
          defaultValue={format(endOfMonth(new Date()), 'yyyy-MM-dd')}
        />
        <NumberInput source="amount" label="Общая стоимость" />
        <DateInput
          label="Действует до"
          source="dateEnd"
          defaultValue={format(endOfMonth(new Date()), 'yyyy-MM-dd')}
        />
        <TextInput
          label="Email пользователя платформы"
          source="userEmail"
          type="email"
        />
        <TextInput
          source="bankDetails.account"
          label="Номер расчетного счета"
        />
        <TextInput
          source="bankDetails.correspondentAccount"
          label="Номер корреспондентского счета"
        />
        <TextInput source="bankDetails.bic" label="БИК" />
        <TextInput
          source="bankDetails.name"
          label="Полное наименование банка"
        />
        <SelectInput
          source="licenseeStatus"
          label="Статус лицензиата"
          choices={choices}
          onChange={(e) => {
            setLicenseeStatus(e.target.value);
          }}
        />
        {isLegal && <TextInput source="legal.name" label="Наименование" />}
        {isLegal && (
          <TextInput source="legal.legalAddress" label="Юридический адрес" />
        )}
        {isLegal && (
          <TextInput source="legal.postalAddress" label="Почтовый адрес" />
        )}
        {isLegal && <TextInput source="legal.inn" label="ИНН" />}
        {isLegal && <TextInput source="legal.kpp" label="КПП" />}
        {isLegal && <TextInput source="legal.ogrn" label="ОГРН" />}
        {isLegal && <TextInput source="legal.phone" label="Телефон" />}
        {isLegal && <TextInput source="legal.email" label="Email" />}
        {isLegal && (
          <TextInput source="legal.fio" label="ФИО Генерального директора" />
        )}
        {isIndividualEntrepreneur && (
          <TextInput source="individualEntrepreneur.fio" label="ФИО" />
        )}
        {isIndividualEntrepreneur && (
          <TextInput
            source="individualEntrepreneur.registrationAddress"
            label="Адрес регистрации"
          />
        )}
        {isIndividualEntrepreneur && (
          <TextInput source="individualEntrepreneur.inn" label="ИНН" />
        )}
        {isIndividualEntrepreneur && (
          <TextInput source="individualEntrepreneur.ogrnip" label="ОГРНИП" />
        )}
        {isIndividualEntrepreneur && (
          <TextInput source="individualEntrepreneur.phone" label="Телефон" />
        )}
        {isIndividualEntrepreneur && (
          <TextInput source="individualEntrepreneur.email" label="Email" />
        )}
      </SimpleForm>
    </Create>
  );
};
